import React from 'react';
import { Card } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area } from 'recharts';

const NPSCharts = ({ selectedChart, selectedDates, chartData }) => {
  if (!chartData || chartData.length === 0) {
    return null;
  }

  // Преобразуем данные для графика
  const formattedData = chartData.map(item => ({
    name: item.day || item.date || item.name,
    nps: item.averageScore || item.nps || 0,
  }));

  // Вычисляем средний NPS за период
  const totalNPS = formattedData.reduce((sum, item) => sum + (item.nps || 0), 0);
  const averageNPS = formattedData.length > 0 && totalNPS > 0
    ? (totalNPS / formattedData.length).toFixed(1)
    : '0.0';

  console.log('NPSCharts - chartData:', chartData);
  console.log('NPSCharts - formattedData:', formattedData);
  console.log('NPSCharts - averageNPS:', averageNPS);

  let chartTitle = '';

  switch (selectedChart) {
    case 'week':
      chartTitle = 'Средний NPS по дням недели';
      break;
    case 'period':
      chartTitle = selectedDates.length
        ? `Средний NPS за период: ${selectedDates.map(date => date.format('DD.MM.YYYY')).join(' - ')}`
        : 'Средний NPS за период';
      break;
    default:
      chartTitle = 'Средний NPS';
  }

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <Card size="small" style={{ border: '1px solid #d9d9d9' }}>
          <p style={{ margin: 0, fontWeight: 600 }}>{payload[0].payload.name}</p>
          <p style={{ margin: 0, color: '#1890ff' }}>
            NPS: {payload[0].value.toFixed(1)} / 5
          </p>
        </Card>
      );
    }
    return null;
  };

  return (
    <Card
      bordered={false}
      style={{ marginBottom: '24px', borderRadius: '8px' }}
      title={
        <div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600 }}>{chartTitle}</h2>
          <div style={{ marginTop: '12px', fontSize: '32px', fontWeight: 700, color: '#1890ff' }}>
            {averageNPS}
          </div>
        </div>
      }
    >
      <ResponsiveContainer width="100%" height={400}>
        <AreaChart
          data={formattedData}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorNps" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1890ff" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#1890ff" stopOpacity={0.1} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="name"
            style={{ fontSize: '14px' }}
            tick={{ fill: '#595959' }}
          />
          <YAxis
            domain={[0, 5]}
            style={{ fontSize: '14px' }}
            tick={{ fill: '#595959' }}
            label={{ value: 'Оценка', angle: -90, position: 'insideLeft', style: { fill: '#595959' } }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            wrapperStyle={{ paddingTop: '20px' }}
            formatter={() => 'Средний NPS'}
          />
          <Area
            type="monotone"
            dataKey="nps"
            stroke="#1890ff"
            strokeWidth={3}
            fillOpacity={1}
            fill="url(#colorNps)"
            animationDuration={1000}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default NPSCharts;
